import React, { Component} from 'react';
import { Button } from 'react-bootstrap';
import './Tour.scss';

let stepNumber = 0;

let steps = [];

function CircleElement(index){
  let step = steps.filter(step => step.index === index)[0];
  let circle = document.querySelector("#tour-circle");
  let textTitle = document.getElementById("tour-title");
  let textDescription = document.getElementById("tour-description");
  textTitle.innerText = step.title;
  textDescription.innerHTML = step.text;

  circle.classList.remove("active");
  if(step && step !== undefined){
    let elem = document.querySelector(step.selector);
    let elemBoundings = elem.getBoundingClientRect();   
    
    setTimeout(function(){
      circle.style.transform = `translate(${elemBoundings.left}px,${elemBoundings.top}px)`;
      circle.style.width = elemBoundings.width + "px";
      circle.style.height = elemBoundings.height + "px";
      circle.classList.add("active");

      if(step && step !== undefined && step.onclick !== undefined){
        step.onclick.forEach(element => {
          document.querySelector(element.selector).click();
        });
      }

      if(step && step !== undefined && step.addText !== undefined){
        let namespaceTab = document.querySelector(`[name="namespace"]`);
        let namespaceContainer = document.querySelectorAll(".namespace-container");
        let namespaceinfocontainer = document.querySelector(".namespace-info-container");
        namespaceTab.click();
       
        if(namespaceContainer && namespaceContainer.length > 0){
          //Do nothing as the element is already on the screen and accessible by the tour
        } else {
          elem.value = step.addText;
          let div = document.createElement("div");
          div.className= "namespace-container card demo-data"
          div.innerHTML = `<div class="card-header"><h4>Smart &amp; Final Stores LLC<span class="accord-collapse"></span></h4><h6>smartfinal</h6></div><div class="collapse show"><div class="card-body"><section class="section-2"><p><strong>CTM:</strong>  <span><a href="mailto:Allen.Sullivan@ceridian.com">Allen Sullivan</a></span></p><p><strong>POD Lead:</strong>  <span><a href="mailto:Raj.Luza@ceridian.com">Raj Luza</a></span></p><p><strong>POD Manager:</strong>  <span><a href="mailto:Helee.Johry@ceridian.com">Helee Johry</a></span></p><p><strong>Sales Rep:</strong>  <span><a href="mailto:Philip.Farrell@ceridian.com">Philip Farrell</a></span></p><p><strong>TAM:</strong>  <span><a href="mailto:Nikisha.Preston@ceridian.com">Nikisha Preston</a></span></p><p><strong>Support Pod:</strong>  <span>ENT-1</span></p><p><strong>Transition To Support Date:</strong>  <span>2015-02-04</span></p></section><section class="section-3"><h5 style="color: rgb(33, 37, 41);">Environment Info<button type="button" class="btn btn-link"><i class="fas fa-tools"></i></button></h5><div><div style="line-height: 1.2;"><div><strong>Namespace</strong><p>smartfinal</p><strong>ClientId</strong><p>20535</p><strong>URL</strong><p><a href="https://usr57.dayforcehcm.com" target="_blank" rel="noopener noreferrer">usr57.dayforcehcm.com</a></p><strong>Version</strong><p>57.4.4.04517</p></div></div></div><button type="button" class="btn btn-link" style="font-size: smaller; padding: 0px;">Hide Dashboard info</button></section></div></div><div class="morph-border"></div>`
          namespaceinfocontainer.prepend(div);
        }
      }

      if((step && step !== undefined ) && step.index > (steps.length - 2)){
        let demoData = document.querySelectorAll(".demo-data");
        let smartNamespace = document.querySelectorAll("#smart-namespace");
        if(demoData.length > 0){
          demoData[0].remove();
          smartNamespace[0].value = "";
        }
      }
    },300);
    
  } else {
    
  }
  
}
export default class FetchTour extends Component {
    constructor(props){
      super(props);

      this.state = {
       isTour : false,
       TourNeeded: false,
       searchCommit: false,
       exitvisible: false
      };
    }

    async componentDidMount(){
      fetch(`${process.env.PUBLIC_URL}/steps.json`)
        .then(success => success.json())
        .then(data =>{
          steps = data;
          stepNumber = 0;
          this.setState({
            runTour: true
          });
          CircleElement(stepNumber);
        });
    }

    nextStep(){
      stepNumber = stepNumber + 1;
      if(stepNumber > (steps.length - 2)){
        this.setState({
          exitvisible: true
        });
      }
      CircleElement(stepNumber);
    }

    async Exit(){
        this.setState({
          isTour : false,
          runTour : false,
          exitvisible: false
        });
        stepNumber = 0;
        this.props.TourCompleted(true);
    }

  render(){
    return (     
      <div id="Tour">
          <div id="FetchTour">
            <div id="tour-circle">
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 152.9 43.4" style={{enableBackground: "new 0 0 152.9 43.4"}} xmlSpace="preserve">
                <path d="M151.9,13.6c0,0,3.3-9.5-85-8.3c-97,1.3-58.3,29-58.3,29s9.7,8.1,69.7,8.1c68.3,0,69.3-23.1,69.3-23.1 s1.7-10.5-14.7-18.4" />
              </svg>
            </div>        
            <section className="tour-wording p-3">
              <div className="w-75 mx-auto" style={{color : "white"}}>
                <h1 id="tour-title">Starting Tour</h1>
                <p id="tour-description"></p>
                {this.state.exitvisible ?
                  <Button className="tour-btn" onClick={() => this.Exit()}>Exit</Button>
                  :
                  <Button className="tour-btn" onClick={() => this.nextStep()}>Next</Button>
                }
              </div>
            </section>
          </div>
      </div>
      
    );
  }
}